export default __webpack_public_path__ + "static/media/the-don.331c3b9b.svg";